import type { ApiFileUploadType } from '#/api/types/ApiFileUploadType';
import type { ApiUser } from '#/api/userEnvironment/types/ApiUserEnvironment';
import { getUserType } from '#/utils/analytics/helpers/getUserType';
import { trackEvent } from '#/utils/analytics/track/trackEvent';

type Args = {
  file: File;
  fileType: ApiFileUploadType;
  user: ApiUser | null;
  extraAnalyticsData: Record<string, unknown> | null;
};

export function trackFileUploaded({
  file,
  fileType,
  user,
  extraAnalyticsData,
}: Args) {
  // Skip tracking for CMS files
  if (fileType === 'CMS_UPLOAD') return;

  trackEvent('Success: Uploaded File', {
    file_type: fileType,
    file_extension: file.name?.split('.').pop(),
    user_type: getUserType(user),
    ...extraAnalyticsData,
  });
}
